import React from "react";

const images = [
  "/Wedding.png",
  "/Taj.png",
  "/Badminton.png",
  "/Kaffee.png",
  "/Yoga.png",
  "/Laser.png"
];

const positiveWords = [
  "Love", "Laughter", "Trust", "Adventure", "Joy",
  "Kindness", "Hugs", "Friendship", "Dancing",
  "Sweet Moments", "Dreams", "Togetherness",
  "Support", "Happiness", "Forever", "Sparkle"
];

const AboutUs = () => {
  return (
    <div className="p-4 sm:p-6 md:p-8 max-w-5xl mx-auto text-gray-800" style={{ color: '#1f2937' }}>
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-6">About Us – Thabo & Thuci</h1>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Couple ${index + 1}`}
            className="w-full h-88 sm:h-80 md:h-80 object-cover rounded-xl shadow-md"
          />
        ))}
      </div>

      <div className="bg-white shadow-md rounded-lg p-4 sm:p-6 text-sm sm:text-base md:text-lg leading-relaxed mb-6" style={{ color: '#1f2937' }}>
        <p>
          Where do we begin? Let’s just say it started with a small mistake – Thabo accidentally took Thuci’s Starbucks coffee… and with it, stole her heart. From that day on, it’s been love, laughter, and the eternal debate over whether pineapple belongs on pizza.
        </p>
        <p className="mt-4">
          Thabo is a tech magician, meme connoisseur, and the unofficial president of the midnight snack club. Thuci – queen of creativity, Pinterest wizard, and finder of all lost keys. Together, we're a Netflix dream team – part drama, mostly comedy!
        </p>
        <p className="mt-4">
          This page? It's our little love scrapbook. We’re so happy to share this beautiful chapter of our story with you. Read it, smile, maybe tear up a little – but not too much, we’ll need tissues for the wedding!
        </p>
      </div>

      <div className="text-center text-xs sm:text-sm text-gray-500 px-2 mb-8">
        P.S. Want to see us live and in love? Come to the wedding! Spoiler alert: there will be dancing, cake, and Thabo’s legendary moonwalk!
      </div>

      <div className="bg-pink-50 rounded-2xl p-6 sm:p-8 shadow-inner">
        <h2 className="text-xl sm:text-2xl font-semibold text-center mb-6 text-gray-800">Words That Define Us 💖</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 text-center">
          {positiveWords.map((word, index) => (
            <div
              key={index}
              className="bg-white text-pink-700 text-sm sm:text-base font-semibold py-2 px-3 rounded-full shadow"
            >
              {word}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
